import React, { useMemo } from 'react'
import { Route, Switch } from 'react-router-dom'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import HourlyEvent from './HourlyEvent'
import UnitHourly from './UnitHourly'

const AeciHourlyEventcontainer = ({ actionPermits, envConfig }) => {
  const hasAccess = useMemo(
    () =>
      hasAccesPermits({
        authGodMode: envConfig && envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.AECI_UNITHOURLY_READ,
          ScreenPermissions.AECI_UNITHOURLY_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig]
  )

  if (!hasAccess) return <div />

  return (
    <Switch>
      <Route
        path="/aeci/unit-hourly"
        exact
        render={() => (
          <UnitHourly actionPermits={actionPermits} envConfig={envConfig} />
        )}
      />
      <Route path="/aeci/hourly-event" exact component={HourlyEvent} />
    </Switch>
  )
}

export { AeciHourlyEventcontainer }
